export enum PromoteGender {
  MALE = "male",
  FEMALE = "female",
  THEM = "them/they",
}
